import { ChangeDetectionStrategy, Component, Input, OnChanges, Self, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-bui-slide-toggle',
  templateUrl: './bui-slide-toggle.component.html',
  styleUrls: ['./bui-slide-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuiSlideToggleComponent implements ControlValueAccessor, OnChanges {
  @Input() label: string;
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() tooltip: string;
  @Input() disabled: boolean;
  @Input() hideTooltip: boolean;

  changeFn;

  constructor(@Self() public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      if (this.disabled === true) {
        this.ngControl?.control?.disable();
      }
    }
  }

  onChange(event: MatSlideToggleChange): void {
    if (this.changeFn) {
      this.changeFn(event.checked);
    }
  }

  registerOnChange(fn: any): void {
    this.changeFn = fn;
  }

  registerOnTouched(): void {
  }

  setDisabledState(): void {
  }

  writeValue(): void {
  }
}
